/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("WindowResizedSpecialAction", ["ActionApplicationService"], function (context, cls) {
  /**
   * @class WindowResizedSpecialAction
   * @memberOf classes
   */
  class WindowResizedSpecialAction /** @lends classes.WindowResizedSpecialAction.prototype */ {
    /** @param actionService {classes.ActionApplicationService} */
    constructor(actionService) {
      this._actionService = actionService;
      this._listener = context.HostService.onScreenResize(cls.FunctionHelper.debounce(this._onResized.bind(this)));
    }

    destroy() {
      if (this._listener) {
        this._listener();
        this._listener = null;
      }
      this._actionService = null;
    }

    _onResized() {
      if (this._actionService?.hasAction("windowresized")) {
        this._actionService.executeActionByName("windowresized", {
          sendValue: true
        });
      }
    }
  }
  cls.WindowResizedSpecialAction = WindowResizedSpecialAction;
  cls.ActionApplicationService.registerSpecialAction("windowresized", cls.WindowResizedSpecialAction);
});
